import React from 'react'
import Header from './Header'
import {Container,Grid,Button,Divider,FormControl,TextField,RadioGroup,FormControlLabel,Radio} from '@material-ui/core';

import Typography from '@material-ui/core/Typography'
import axios from 'axios'
import Loader1 from './Loader1'
class CustomerSurveyform extends React.Component
{

constructor(props)
{
  super(props)
  this.state={
    location:'',
    name:'',
    email:'',
    tel:'',
    question1:'',
    question2:'',
    question3:'',
    question4:'',
    value:'',
    successmsg:'',
    errors:{},
    loading:false

  }
  
  
}

  handleChange=(event)=>
  {
    let name= event.target.name;
    let val=event.target.value
    this.setState({[name]:val})
   
    //this.validateForm()
   
  } 
   
  handleSubmit=(event)=>
  {

    if(this.validateForm())
    {
    const postdata={
      location: this.state.location,
      name: this.state.name,
      email:this.state.email,
      tel:this.state.tel,
      question1:this.state.question1,
      question2:this.state.question2,
      question3: this.state.question3,
      question4: this.state.question4

    }
    this.setState({loading:true})
    let axiosheader={
      headers: {
      'Content-Type' : 'application/json;charset=UTF-8',
      'Accept': 'Token',

      'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type',
      'Access-Control-Allow-Methods': 'POST, GET, OPTIONS, PUT, DELETE',
      "Access-Control-Allow-Origin": "*",
  
    }
    }

axios({
method:"post",
url:"http://localhost/customersurvey/insert.php",
mode: 'no-cors',
withCredentials: false,
header : axiosheader, 
crossDomain: true ,
data: postdata

}).then(res=>{
  //let name= event.target.name;
  this.setState({loading:false})
  this.setState({location:''})
  this.setState({name:''})
  this.setState({email:''})
  this.setState({tel:''})
  this.setState({question1:''})
  this.setState({question2:''})
  this.setState({question3:''})
  this.setState({question4:''})

 
  this.setState({successmsg:"Record Saved Successfully"}) 
  //setTimeout(()=>window.location.reload(),10000)
//setTimeout(()=>window.location.reload(), 5000);
  //this.setState({[name]:''})
 

 // console.log('fff')
})
    }
   

  }
componentDidUpdate()
{
 // this.setState({successmsg:''})
  setTimeout(() => this.setState({successmsg:''}), 10000);
}  
validateForm()
{
let formIsValid=true
let errors={}
if(!this.state.location)
{
errors['location']='Please Enter Location'
}
if(!this.state.name)
{
formIsValid=false  
errors['username']='Please Enter Name'

  }
  if(!this.state.email)
  {
  formIsValid=false  
  errors['emailid']='Please Enter Email'
  
    }

if(!this.state.tel)
{
  formIsValid=false
  errors['tel']='Please Enter Telephone'

}

if(!this.state.question1)
{
 formIsValid=false
 errors['question1']='Please select your Shopping Experience in Nabeel Showroom'
}
if(!this.state.question2)
{
 formIsValid=false
 errors['question2']='Please select your fragrance'
}
if(!this.state.question3)
{
 formIsValid=false
 errors['question3']='Did you get your shopping invoice?'
}
if(!this.state.question4)
{
 formIsValid=false
 errors['question4']='Please enter your suggestions'
}


this.setState({errors:errors})
return formIsValid;

  }

  
render()
{

  
 /* const usestyles=makeStyles((theme)=>{
  })*/
  const err={
   color:"#f00"
  }
  const top100Films = [
    { title: 'The Shawshank Redemption', year: 1994 },
    { title: 'The Godfather', year: 1972 },
    { title: 'The Godfather: Part II', year: 1974 },
    { title: 'The Dark Knight', year: 2008 },
    { title: '12 Angry Men', year: 1957 },
    { title: "Schindler's List", year: 1993 },
    { title: 'Pulp Fiction', year: 1994 },
    { title: 'The Lord of the Rings: The Return of the King', year: 2003 },
    { title: 'The Good, the Bad and the Ugly', year: 1966 },
    { title: 'Fight Club', year: 1999 },
    { title: 'The Lord of the Rings: The Fellowship of the Ring', year: 2001 }
  ];
 if(this.state.loading) return <Loader1 />
  return(
  <>    
  <Container maxWidth="md"> 
  <Header />  
  <div className='surveyBox'>
  <Typography component='h1' variant='h5'>CUSTOMER SURVEY FORM</Typography>
  <h1 style={{color:"green"}}>{this.state.successmsg}</h1>
  <form>
  <Grid container xs={12}> 
  <Grid item xs={12} > 
  <FormControl component="fieldset">
  
  <div >
   <select name='location' onChange={this.handleChange}  variant="outlined" >
    <option value="">Select Location</option>
   <option value="Murshid Showroom">Murshid Showroom</option>
    <option value="Souq Okadh">Souq Okadh</option>
    <option value="Dubai Mall Kiosk">Dubai Mall Kiosk</option>
    <option value="Dubai Outlet Mall">Dubai Outlet Mall</option>
    <option value="Rolla Showroom">Rolla Showroom</option>
    <option value="Matajer Al Qouz">Matajer Al Qouz</option>
    <option value="Oasis Mall">Oasis Mall</option>
    <option value="Factory Outlet">Factory Outlet</option>
    <option value="Dalma Mall Showroom">Dalma Mall Showroom</option>
    <option value="BAS Mall">BAS Mall</option>
    <option value="BAB Sharief Jeddah">BAB Sharief Jeddah</option>
    <option value="AL fahaheel Kuwait">AL fahaheel Kuwait</option>
  </select>
  </div>
  <div style={err}>{this.state.errors.location}</div>
 </FormControl>  
  </Grid>

  <Grid item xs={12} > 
  <FormControl component="fieldset">
  <TextField id="standard-basic"  margin="normal" name="name"  variant="outlined" label='Name' value={this.state.name} onChange={this.handleChange} required /> 
  <div style={err}>{this.state.errors.username}</div>
  </FormControl>
  </Grid>
  <Grid item xs={12} > 
  <FormControl component="fieldset">
  <TextField id="standard-basic" margin="normal"  name="email" variant="outlined" label='Email' value={this.state.email} onChange={this.handleChange}/> 
  <div style={err}>{this.state.errors.emailid}</div>
  </FormControl> 
 </Grid>
 <Grid item xs={12} >      
  <FormControl component="fieldset">
  <TextField id="standard-basic" fullWidth  margin="normal"  name="tel" variant="outlined"  label='Tel'  value={this.state.tel}  onChange={this.handleChange}/> 
  <div style={err}>{this.state.errors.tel}</div>
  </FormControl>
 </Grid>
  <Grid item xs={12}  > 
  <FormControl component="fieldset" style={{paddingTop:20,paddingBottom:20 }}>
  A) How do you rate your shopping experience in Nabeel showrooms?
  <RadioGroup aria-label="question1" name="question1" value={this.state.question1} onChange={this.handleChange} style={{paddingTop:10 }}>
  <FormControlLabel value="Excellent" control={<Radio />} label="Excellent" />
  <FormControlLabel value="Good" control={<Radio />} label="Good" />
  <FormControlLabel value="Fair" control={<Radio />} label="Fair" />
  <FormControlLabel value="Need improvement"  control={<Radio />} label="Need improvement" />
  <FormControlLabel value="Poor"  control={<Radio />} label="Poor" />
  </RadioGroup>
  <div style={err}>{this.state.errors.question1}</div>
  </FormControl>
  </Grid>
  <Grid item xs={12} > 
  <Divider />
<FormControl component="fieldset"  style={{paddingTop:20,paddingBottom:20 }}>
  B) What kind of fragrances do you normally purchase?
  <RadioGroup aria-label="question2" name="question2" value={this.state.question2} onChange={this.handleChange} style={{paddingTop:10 }}>
  <FormControlLabel value="Woody/ oriental" control={<Radio />} label="Woody/ oriental" />
  <FormControlLabel value="French fragrances" control={<Radio />} label="French fragrances" />
  <FormControlLabel value="French-oriental" control={<Radio />} label="French-oriental" />
  <FormControlLabel value="Floral"  control={<Radio />} label="Floral" />
  </RadioGroup>
  <div style={err}>{this.state.errors.question2}</div>
  </FormControl>
  <Divider />
<FormControl component="fieldset"  style={{paddingTop:20,paddingBottom:20 }}>
  C) Did you get the shopping invoice with a thankyou note post your purchase from Nabeel showrooms?
  <RadioGroup aria-label="question3" name="question3" value={this.state.question3} onChange={this.handleChange} style={{paddingTop:10 }}>
  <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
  <FormControlLabel value="No" control={<Radio />} label="No" />
  </RadioGroup>  
  <div style={err}>{this.state.errors.question3}</div> 
  </FormControl>   
  <Divider />
<FormControl component="fieldset"  style={{paddingTop:20 }}>
  D) Any suggestions that you would like to give to us ?
  <TextField id="standard-basic" name='question4' fullWidth  value={this.state.question4} margin="normal" variant="outlined"   multiline onChange={this.handleChange}  /> 
  <div style={err}>{this.state.errors.question4}</div> 
</FormControl>
</Grid>
<Grid item xs={12}  style={{paddingTop:20}} > 
<Button variant="contained" color="secondary" onClick={this.handleSubmit} >Submit</Button></Grid>
</Grid></form>
</div>
</Container>
 </>           
    )
    
}

}
export default CustomerSurveyform;